import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateDistrictMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createDistrictApi(data) {
    try {
      const api = `/district`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createDistrictApi", ...keyData],
    mutationFn: (data) => createDistrictApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("districts");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createDistrict: mutateAsync };
}

export function useUpdateDistrictMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateDistrictApi(data) {
    try {
      const api = `/district`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateDistrictApi", ...keyData],
    mutationFn: (data) => updateDistrictApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("districts");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateDistrict: mutateAsync };
}

export function useDeleteDistrictMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteDistrictApi(id) {
    try {
      const api = `/district/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteDistrictApi", ...keyData],
    mutationFn: (data) => deleteDistrictApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("districts");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteDistrict: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllDistrictQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllDistrictApi(query) {
    try {
      const api = `/districts${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllDistrict-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllDistrictApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}
